import { createInstance, Config } from "@hackler/react-sdk";

const config: Config = {
  auto_track_page_view: true,
};
export const HackleClient = createInstance(
  process.env.NEXT_PUBLIC_HACKLE_BROWSER_SDK_KEY as string,
  config,
);
